import wordmark from '@/assets/logos/icon-wordmark-svg/icon-wordmark.svg';
import { useWhiteLabelSafe } from '@/context/white-label';
import { cn } from '@/lib/cn';
import Image from 'next/image';
import { memo } from 'react';

interface BrandWordmarkSvgProps {
  alt: string;
  height: number;
  className?: string;
  /** When true, preloads the image to prevent flash on remount (e.g., in sidebar) */
  priority?: boolean;
}

export const BrandWordmarkSvg = memo(
  ({ alt, height, className, priority = false }: BrandWordmarkSvgProps) => {
    const { isWhiteLabel, partnerName } = useWhiteLabelSafe();

    // In white-label mode, show partner name as text instead of Heidi wordmark
    if (isWhiteLabel && partnerName) {
      return (
        <span
          className={cn(
            'inline-flex items-center whitespace-nowrap font-semibold leading-none',
            className
          )}
          style={{ height, fontSize: height * 0.7 }}
        >
          {partnerName}
        </span>
      );
    }

    // viewBox is 605x136 (cropped to content bounds), aspect ratio is ~4.45:1
    const aspectRatio = 605 / 136;
    const width = Math.round(height * aspectRatio);

    return (
      <Image
        src={wordmark}
        alt={alt}
        width={width}
        height={height}
        className={cn('dark-invert', className)}
        priority={priority}
      />
    );
  }
);

BrandWordmarkSvg.displayName = 'BrandWordmarkSvg';
